<template>
  <transition mode="out-in">
    <router-view />
  </transition>
</template>

<script>
export default {
  name: "accountmessage",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateY(180deg);
}
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/account/accountmessage.vue